import React, { useContext, useState } from 'react'
import ProfilesPage from '.'
import Profiles from './Profiles'
import { Switch } from 'components/Form'
import { AssessmentsContext } from 'pages/School/Assessments/AssessmentsContext'

const WrapProfiles = () => {
    const { profileFilters: filters, setProfileFilters: setFilters } = useContext(AssessmentsContext)
    const [visibleRatings, setVisibleRatings] = useState({ "1": true, "2": true, "3": true, "4": true, "5": true })
    const [showDetails, setShowDetails] = useState(false)

    return (
        <ProfilesPage
            visibleRatings={visibleRatings}
            setVisibleRatings={setVisibleRatings}
            filters={filters}
            setFilters={setFilters}
            showDetails={showDetails}
            title="חלוקה לפי רמות קריאה"
            subTitle={(totalCount) => `כאן אפשר לראות את ${totalCount || "רשימת"} תלמידים מחולקים לפי ביצועי שטף הקריאה שלהם, ולזהות במהירות מי זקוק לחיזוק`}
            customToolbar={
                <div className='view-options-btns'>
                    <Switch
                        label="פרטי כיתה"
                        input={{
                            value: showDetails,
                            onChange: setShowDetails
                        }} />
                </div>}
        >
            <Profiles />
        </ProfilesPage>
    )
}

export default WrapProfiles